import type { DailyRoutineDetails } from '../dto/DailyRoutineDetails';
import type { DailyStepRepository } from '../ports/DailyStepRepository';
import type { EmotionalProtocolLogRepository } from '../ports/EmotionalProtocolLogRepository';
import { fromEmotionalStateData } from '../../domain/emotion/EmotionalStateContent';
import { calculateDailyProgress } from '../../domain/progression/CalculateDailyProgress';
import { selectActiveSteps } from '../../domain/routine/DayModeRules';
import type { DailyRoutine } from '../../domain/routine/models';

export async function loadRoutineDetails(
  routine: DailyRoutine,
  dailySteps: DailyStepRepository,
  emotionalProtocolLogs: EmotionalProtocolLogRepository,
): Promise<DailyRoutineDetails> {
  const steps = await dailySteps.listByRoutine(routine.id);
  const log = await emotionalProtocolLogs.findByLogicalDate(routine.profileId, routine.logicalDate);
  return {
    routine,
    steps,
    progress: calculateDailyProgress(selectActiveSteps(steps, routine.dayMode)),
    emotionalState: (log && fromEmotionalStateData(log.data)?.state) ?? null,
  };
}
